
export class TaleoftheTape {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Tale of the Tape";
    this.scene = "Tale of the Tape";
    this.data = [];
    this.page = 9350;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "006";
      }).value = (options?.game?.home_fighter?.first_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "007";
      }).value = (options?.game?.home_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "008";
      }).value = (options?.game?.away_fighter?.first_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "009";
      }).value = (options?.game?.away_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0321";
      }).value = (options?.game?.home_fighter?.weight.toUpperCase() || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0322";
      }).value = (options?.game?.away_fighter?.weight.toUpperCase() || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0121";
      }).value = (options?.game?.home_fighter?.age || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0122";
      }).value = (options?.game?.away_fighter?.age || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0421";
      }).value = (options?.game?.home_fighter?.reach || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0422";
      }).value = (options?.game?.away_fighter?.reach || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0221";
      }).value = (options?.game?.home_fighter?.height || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0222";
      }).value = (options?.game?.away_fighter?.height || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0120";
      }).value = "AGE";

      xml.payload.field.find((item) => {
        return item.attr.name === "0320";
      }).value = "WEIGHT";

      xml.payload.field.find((item) => {
        return item.attr.name === "0420";
      }).value = "REACH";

      xml.payload.field.find((item) => {
        return item.attr.name === "0220";
      }).value = "HEIGHT";

      xml.payload.field.find((item) => {
        return item.attr.name === "P2001";
      }).value =
        options?.game?.competition?.fighter_full_path +
        (options.game?.away_fighter?.image || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "P2002";
      }).value =
        options?.game?.competition?.fighter_full_path +
        (options.game?.home_fighter?.image || "");

      
      xml.payload.field.find((item) => {
        return item.attr.name === "001";
      }).value = "TALE OF THE TAPE";

      xml.payload.field.find((item) => {
        return item.attr.name === "0095";
      }).value = options?.game?.title || "";
      

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
